import React from "react"

import type { LucideIcon } from "lucide-react"

import { TableCell, TableRow } from "@/components/ui/table"
import { cn } from "@/lib/utils"

export function EmptyState({
  icon: Icon,
  children,
  className,
}: {
  icon?: LucideIcon
  children: React.ReactNode
  className?: string
}) {
  return (
    <div className={cn("py-12 text-center text-palette-jungleGreen500", className)}>
      {Icon && (
        <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-palette-jungleGreen100">
          <Icon className="h-8 w-8 text-palette-jungleGreen400" />
        </div>
      )}
      <p>{children}</p>
    </div>
  )
}

export function TableEmptyRow({
  colSpan,
  children,
}: {
  colSpan: number
  children: React.ReactNode
}) {
  return (
    <TableRow>
      <TableCell colSpan={colSpan} className="py-8 text-center text-palette-jungleGreen500">
        {children}
      </TableCell>
    </TableRow>
  )
}
